
import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      toastOptions={{
        duration: 2000, // Slightly longer toast duration for better readability
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#0D0F21]/95 group-[.toaster]:text-white group-[.toaster]:border-[#6C41E0]/30 group-[.toaster]:shadow-lg group-[.toaster]:shadow-[#6C41E0]/15 group-[.toaster]:rounded-xl group-[.toaster]:backdrop-blur-md",
          title: "group-[.toast]:text-white group-[.toast]:font-medium",
          description: "group-[.toast]:text-white/80",
          actionButton:
            "group-[.toast]:bg-[#6C41E0] group-[.toast]:text-white group-[.toast]:rounded-lg group-[.toast]:hover:bg-[#7B52F0] group-[.toast]:transition-colors",
          cancelButton:
            "group-[.toast]:bg-[#30324E] group-[.toast]:text-white group-[.toast]:rounded-lg group-[.toast]:hover:bg-[#40425E] group-[.toast]:transition-colors",
          closeButton: 
            "group-[.toast]:bg-[#30324E] group-[.toast]:text-white/80 group-[.toast]:hover:text-white group-[.toast]:hover:bg-[#40425E] group-[.toast]:transition-colors",
          success: 
            "group-toast-success:border-green-500/30 group-toast-success:bg-gradient-to-r group-toast-success:from-[#0D0F21]/95 group-toast-success:to-green-950/30",
          error: 
            "group-toast-error:border-red-500/30 group-toast-error:bg-gradient-to-r group-toast-error:from-[#0D0F21]/95 group-toast-error:to-red-950/30",
          info: 
            "group-toast-info:border-blue-500/30 group-toast-info:bg-gradient-to-r group-toast-info:from-[#0D0F21]/95 group-toast-info:to-blue-950/30",
          warning: 
            "group-toast-warning:border-yellow-500/30 group-toast-warning:bg-gradient-to-r group-toast-warning:from-[#0D0F21]/95 group-toast-warning:to-yellow-950/30",
        },
      }}
      richColors
      closeButton
      {...props}
    />
  )
}

export { Toaster }
